<script lang="ts">
  import AnimatedSection from '$components/AnimatedSection.svelte';
  import { m } from '$lib/paraglide/messages.js';
  import { VISA_ORDER, VISA_META } from '$data/visa-data';
  import { VISA_TEXT } from '$lib/content';
</script>

<section data-theme="dark" class="bg-charcoal py-[10vh] md:py-[14vh] px-[4vw]">
  <div class="max-w-[1400px] mx-auto">
    <span class="font-accent uppercase text-[0.7rem] tracking-[0.15em] text-warm-gold block mb-[3vh]">{m.visa_categories_label()}</span>
    <h2 class="font-display text-[clamp(1.5rem,3.5vw,3rem)] text-parchment leading-[1.15] mb-[4vh] md:mb-[6vh]">
      {m.visa_categories_heading()}
    </h2>
    <p class="font-body text-[1rem] text-parchment/65 leading-[1.6] max-w-[780px] mb-[4vh] md:mb-[5vh]">
      {m.visa_categories_notice()}
    </p>

    <AnimatedSection className="grid grid-cols-2 md:grid-cols-4 gap-px bg-charcoal/50" direction="up" stagger={0.06}>
      {#each VISA_ORDER as id}
        {@const meta = VISA_META[id]}
        <article class="relative bg-charcoal p-5 md:p-6 text-left">
          <span class="font-display text-[clamp(1.5rem,2.5vw,2rem)] text-parchment tracking-[-0.01em] leading-none block">
            {meta.code}
          </span>
          <span class="font-accent uppercase text-[0.55rem] md:text-[0.6rem] tracking-[0.1em] text-warm-gold/80 block mt-2">{VISA_TEXT[id].subtitle()}</span>
          <span class="font-body text-[1rem] text-parchment/70 leading-[1.5] block mt-3 pr-6">
            {VISA_TEXT[id].cardDetails()}
          </span>
        </article>
      {/each}
    </AnimatedSection>
  </div>
</section>
